"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PasteSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M22 6h-2a2 2 0 00-2-2h-1.18a2.99 2.99 0 00-5.64 0H10a2 2 0 00-2 2H6a2 2 0 00-2 2v20a2 2 0 002 2h4v-2H6V8h2a2 2 0 002 2h8a2 2 0 002-2h2v2h2V8a2 2 0 00-2-2zm-4 2h-8V6h3V5a1 1 0 012 0v1h3z"/><path d="M26 12H14a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V14a2 2 0 00-2-2zm-3 10h-6a1 1 0 010-2h6a1 1 0 010 2zm0-4h-6a1 1 0 010-2h6a1 1 0 010 2z"/>';
var PasteSVG = function PasteSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PasteSVG = PasteSVG;
PasteSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PasteSVG);
exports.default = _default;